import React from "react";
import CpwdTenderResultsPage from "../cpwd/CpwdTenderResultsPage";

export default function AdminCpwdTenderResultsPage() {
  return <CpwdTenderResultsPage admin={true} />;
}
